/*jshint esversion: 6 */
import MobileMenu from './MobileMenu.js';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import FaBars from 'react-icons/lib/fa/bars';
import '../css/PageHead.css';


class PageHead extends Component {

  constructor(props){
    super(props);
    this.state = {
      pagetitles: props.pagetitles,
      isMobileToggleOn: false
    };
    this.handleClick = this.handleClick.bind(this);
    this.mobileMenuClick = this.mobileMenuClick.bind(this);
  }

  mobileMenuClick(mdata, evt){
    this.handleClick();
    window.location.href = mdata;
    console.log("mobileMenuClick mdta", mdata);
    if(evt){
      console.log("mobileMenuClick evt", evt);
      if(evt.target)
        console.log("mobileMenuClick evt.target", evt.target.value);
    }
  }
  handleClick() {
    console.log("IS Mobile Visible? HEAD", this.state.isMobileToggleOn)
    this.setState(prevState => ({
      isMobileToggleOn: !prevState.isMobileToggleOn
    }));
  }

  render() {
    let pagetitles = this.props.pagetitles;
    //console.log('getPageTitles pages ', pagetitles);
    let pathname = window.location.pathname.toLowerCase();
    // console.log('pathname',pathname);
    // console.log('encodeURI', encodeURI('õppimine'));
    if(pagetitles){
      if(pagetitles.length){
      var menuitems = pagetitles.map((theme, k) => {
        if(theme.parent !== 'avaleht'){
          return(
          <li key={k} className="main_menu_li">
              <Link to={theme.link}>
                  <span className="align_text">{theme.parent}</span>
              </Link>
              <div className={(pathname === encodeURI(theme.link))? "selectedMenuItem" : "notSelectedMarker"}></div>
                  <ul key={'subul'+ k}  className="sub_menu_ul">
                    {theme.subpages.map((sub, si) => {
                       return (
                          <li key={si} className="sub_menu_li">
                            <div className={(si>0)? "subMenuItemDelimiter" : "subMenuItemDelimiter_invisible"}></div>
                            <a href = {sub.link}> 
                                <span className="align_text">{sub.title}</span>
                            </a>
                          </li>
                        )
                    })}
                  </ul>
          </li>
          );
        }
          
      });
    }
  }
   
    
    return (
      <div>
      <div className="nav_menu_back"></div>
      <div className="" >
        <MobileMenu 
            isMobileMenuVisible = {this.state.isMobileToggleOn}
            onClick={(mdata) => this.mobileMenuClick(mdata)}
            pagetitles = {pagetitles}
        />
      </div>

        <nav className="float_center" >
         <div className="hamburger_menu" >
            <FaBars 
              onClick={this.handleClick}
             />
        </div>

        
          <ul className="main_menu_ul distribute_to_center">
            {menuitems}
          </ul>
        </nav>
   </div>
    );
  }

}
  
export default PageHead;


// WEBPACK FOOTER //
// ./src/Components/PageHead.js